export default class Base {
	public isDirty:boolean;
	
		constructor(data?: object) {
		if(data) {
			this.addData(data);
			}
			this.isDirty = false;
			return this;
	}

	public addData(dataObj?: object) {

		if(dataObj && typeof dataObj == 'object') {
			Object.keys(dataObj).forEach(key => {
				if(key in this) {
					let val = dataObj[key];
					if( typeof this[key] == "number" ) {
						val = Number(val);
					} else if( typeof this[key] == "object" && typeof this[key].getDate === "function" ) {
						val = new Date(val)
						console.log(key, val);
					}
					//const newKey = key.substring(1);
					if(val != null) {
						this[key] = val;
					}
				}
			});
		}
		return this;
	}

	public getData(removeEmptyVal = true) {
		const returnObj = {};
		Object.keys(this).forEach(key => {
			let val;
			if(typeof this[key] == 'string' && (this[key] != "" || removeEmptyVal == false) ) {
				val = this[key];
			} if(typeof this[key] == 'number' && (this[key] > 0 || removeEmptyVal == false)) {
				val = this[key];
			}

			if((val || removeEmptyVal == false) && !key.startsWith('_')) {
				//if(val) {
					returnObj[key] = val;
				//}
			} else if((val || removeEmptyVal == false) && key.startsWith('_')) {
				const newKey = key.substring(1);
				const descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(this), newKey);
				if (descriptor && typeof descriptor.get === "function" && typeof descriptor.set === "function") {
					returnObj[newKey] = this[key];
				}
			}
		});
		return returnObj;
	}
		
}